import * as React from 'react';
import SwipeableViews from 'react-swipeable-views';
import { virtualize, bindKeyboard, mod } from './reactSwipeableViews';
import {
  SliderProps,
  VirtualizeSliderProps,
  SlideRendererParams,
} from './types';

export const VirtualizeSwipeableViews = bindKeyboard(
  virtualize(SwipeableViews),
);

export const VirtualizeSlider: React.SFC<
  SliderProps & VirtualizeSliderProps
> = ({
  index,
  slideCount,
  containerStyle,
  slideStyle,
  slideRenderer,
  handleChangeIndex,
}) => (
  <VirtualizeSwipeableViews
    index={index}
    onChangeIndex={handleChangeIndex}
    style={containerStyle}
    slideStyle={slideStyle}
    ignoreNativeScroll
    overscanSlideAfter={slideCount - 1}
    slideRenderer={(params: SlideRendererParams) =>
      slideRenderer({
        index: mod(params.index, slideCount),
        key: params.key,
      })
    }
  />
);
